import clsx from "clsx";
import type { HTMLAttributes } from "react";
import s from "./Kbd.module.css";

export function Kbd({ className, children, ...rest }: HTMLAttributes<HTMLElement>) {
  return (
    <kbd className={clsx(s.kbd, className)} {...rest}>
      {children}
    </kbd>
  );
}
